export const hasRoleAccess = (itemRoles: string[] | undefined, userRoles: string[]): boolean => {
  if (!itemRoles || itemRoles.length === 0) {
    return true;
  }
  return itemRoles.some((role) => userRoles.includes(role));
};
